import { render } from "./NodeDetailMetrics.vue?vue&type=template&id=658eda0c&scoped=true&ts=true"
import script from "./NodeDetailMetrics.vue?vue&type=script&lang=ts"
export * from "./NodeDetailMetrics.vue?vue&type=script&lang=ts"

import "./NodeDetailMetrics.vue?vue&type=style&index=0&id=658eda0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658eda0c"]])

export default __exports__